import { render, staticRenderFns } from "./FaturaDetay.vue?vue&type=template&id=95e4c4da"
import script from "./FaturaDetay.vue?vue&type=script&lang=js"
export * from "./FaturaDetay.vue?vue&type=script&lang=js"
import style0 from "./FaturaDetay.vue?vue&type=style&index=0&id=95e4c4da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports